import { render, staticRenderFns } from "./StudentsByState.vue?vue&type=template&id=667f1111&"
import script from "./StudentsByState.vue?vue&type=script&lang=js&"
export * from "./StudentsByState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports